interface EnquiryAnswer {
  qperc: string;
  qperc_val: string;
}

export interface EnquiryQuestion {
  [questionIndex: string]: EnquiryAnswer;
}

interface EnquiryQuestionOrTotal {
  [questionOrTotalIndex: string]: EnquiryQuestion | string;
}

export interface VoteJson {
  id: string;
  ok: string;
  eid: string;
  val: string;
  data: {
    [selectedAnswerIndex: string]: EnquiryQuestionOrTotal;
  };
}

/**
 * @name voteUrl
 * @description Hlasovat. V odpovědi chodí data s výsledky pro danou anketu.
 *
 * @param {String} answerId
 * @param {String} questionId
 * @returns {String}
 */
export const voteUrl = (answerId: string, questionId: string) =>
  `/enquiries/${answerId}/vote/${questionId}`;

export interface UpdateJson {
  [enquiryIndex: string]: EnquiryQuestionOrTotal;
}

/**
 * @name updateUrl
 * @description Načtení výsledků ankety.
 *
 * @param {String} enquiryId
 * @returns {String}
 */
export const updateUrl = (enquiryId: string) => `/enquiries/${enquiryId}/load`;
